var _rect, _rect2, _rect3, _rect4, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandingPageDesignNib(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Payment Link",
    clipPath: "url(#clip0_8011_14434)",
    filter: "url(#filter0_d_8011_14434)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 5132,
    transform: "translate(-752 -1304)",
    fill: "#141414"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 53251"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 53041"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 53038",
    filter: "url(#filter1_bd_8011_14434)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -36,
    y: -36,
    width: 488,
    height: 268,
    rx: 16,
    fill: "url(#paint0_linear_8011_14434)",
    fillOpacity: 0.15,
    shapeRendering: "crispEdges"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -35.5,
    y: -35.5,
    width: 487,
    height: 267,
    rx: 15.5,
    stroke: "url(#paint1_linear_8011_14434)",
    strokeOpacity: 0.3,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    id: "design-nib 2",
    clipPath: "url(#clip1_8011_14434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8011_14434",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_2585_14438"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M48 0H0V48H48V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8011_14434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35.3495 22.8148L31.5389 34.2464C31.4151 34.6178 31.1179 34.9056 30.7425 35.0172L7.38765 41.9604C6.45707 42.237 5.60025 41.3518 5.90725 40.4308L13.49 17.6824C13.6003 17.3515 13.8491 17.085 14.1716 16.9522L24.9447 12.5162C25.3927 12.3318 25.9077 12.4347 26.2503 12.7773L35.0595 21.5868C35.3809 21.9082 35.4933 22.3836 35.3495 22.8148Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.59375 41.2031L19.3217 28.4751",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M35.5869 22.1113L41.2439 16.4544C42.8059 14.8923 42.8059 12.3596 41.2439 10.7975L37.0013 6.55486C35.4391 4.99278 32.9065 4.99278 31.3443 6.55486L25.6875 12.2117",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M23.5667 24.2327C22.3951 23.0611 20.4955 23.0611 19.324 24.2327C18.1524 25.4043 18.1524 27.3039 19.324 28.4753C20.4955 29.6469 22.3951 29.6469 23.5667 28.4753C24.7381 27.3039 24.7381 25.4043 23.5667 24.2327Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8011_14434",
    x: -756,
    y: -1304,
    width: 1928,
    height: 5140,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8011_14434"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8011_14434",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bd_8011_14434",
    x: -88.4562,
    y: -84.1741,
    width: 592.912,
    height: 372.912,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 13.3817
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8011_14434"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.28214
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.2281
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0283334 0 0 0 0 0.283333 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_8011_14434",
    result: "effect2_dropShadow_8011_14434"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8011_14434",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8011_14434",
    x1: -36,
    y1: -44.3489,
    x2: 94.0279,
    y2: 466.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8011_14434",
    x1: -53.3126,
    y1: -58.9595,
    x2: 74.4995,
    y2: 372.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8011_14434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 5132,
    fill: "white",
    transform: "translate(-752 -1304)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8011_14434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPageDesignNib);
export default __webpack_public_path__ + "static/media/landing-page-design-nib.7cf9c6554b98ab6d547fb02ea6523719.svg";
export { ForwardRef as ReactComponent };